<div class="user">
  <form [formGroup]="formGroup" autocomplete="off">
    <section class="form-section" id="contact-info-section">
      <div class="container">
        <div class="form-row form-row-header-section">
          <div class="col-12">
            <div class="form-section-title">{{ "LABELS.CONTACT_INFO" | translate }}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-sm-6 col-12" id="control-firstName">
            <!-- firstName -->
            <app-control-wrapper [control]="formGroup.get('firstName')" [errors]="errors.firstName">
              <label for="firstName" control-label>
                {{ "LABELS.FIRST_NAME" | translate }}
                <i class="fa fa-asterisk form-required" aria-hidden="true"></i>
              </label>
              <input
                type="text"
                [formControl]="formGroup.get('firstName')"
                class="form-control"
                id="firstName"
                name="firstName"
                [dropSpecialCharacters]="false"
                [patterns]="CUSTOM_MASK"
                [mask]="'N{50}'"
                [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH'"
                [maxMaskLength]="50"
                control-wrapper
              />
            </app-control-wrapper>
          </div>
          <div class="col-sm-6 col-12" id="control-lastName">
            <!-- lastName -->
            <app-control-wrapper [control]="formGroup.get('lastName')" [errors]="errors.firstName">
              <label for="lastName" control-label>
                {{ "LABELS.LAST_NAME" | translate }}
                <i class="fa fa-asterisk form-required" aria-hidden="true"></i>
              </label>
              <input
                type="text"
                [formControl]="formGroup.get('lastName')"
                class="form-control"
                id="lastName"
                name="lastName"
                [dropSpecialCharacters]="false"
                [patterns]="CUSTOM_MASK"
                [mask]="'N{50}'"
                [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH'"
                [maxMaskLength]="50"
                control-wrapper
              />
            </app-control-wrapper>
          </div>
        </div>
        <div class="form-row">
          <div class="col-12" id="control-email">
            <!-- email -->
            <app-control-wrapper [control]="formGroup.get('email')" [errors]="errors.email" helper="FORM_HELPER.EMAIL">
              <label for="email" control-label>{{ "LABELS.EMAIL_ADDRESS" | translate }}</label>
              <input
                type="text"
                [formControl]="formGroup.get('email')"
                class="form-control"
                id="email"
                name="email"
                control-wrapper
                [mask]="'F*'"
                [patterns]="CUSTOM_MASK"
                [appMaskErrorTooltip]="'FORM_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
                [dropSpecialCharacters]="false"
              />
            </app-control-wrapper>
          </div>
        </div>
        <div class="form-row">
          <div class="col-12" id="control-timeZone">
            <app-control-wrapper [control]="formGroup.get('timeZone')" [errors]="errors.timeZone">
              <!--              <label for="timezone" control-label>{{ "LABELS.TIMEZONE" | translate }}</label>-->
              <!--              <ng-moment-timezone-picker-->
              <!--                id="timezone"-->
              <!--                control-wrapper-->
              <!--                [formControl]="formGroup.get('timeZone')"-->
              <!--                [customPlaceholderText]="'FORM_PLACEHOLDER.SELECT' | translate"-->
              <!--                [clearable]="false"-->
              <!--              ></ng-moment-timezone-picker>-->
            </app-control-wrapper>
          </div>
        </div>
        <div class="form-row">
          <div class="col-12" id="control-phoneNumber">
            <!-- phoneNumber -->
            <input-phone
              [fc]="formGroup.get('phoneNumber')"
              [errors]="errors.phoneNumber"
              [label]="'LABELS.MOBILE_NUMBER'"
              [id]="'phoneNumber'"
              [required]="true"
              [helper]="'FORM_HELPER.PHONE_NUMBER'"
              [isShowConfirmed]="user.phoneNumberConfirmed && !isChangedPhoneNumber"
            ></input-phone>
          </div>
        </div>
        <div class="form-row" *ngIf="!user.phoneNumberConfirmed || isChangedPhoneNumber">
          <div class="col-12">
            <button
              type="button"
              class="btn btn-primary verify-btn"
              [disabled]="!formGroup.get('phoneNumber').value"
              (click)="openVerifyModal()"
            >
              {{ (isVerificationCodeExpired ? "BUTTON.VERIFICATION_CODE" : "BUTTON.VERIFY") | translate }}
            </button>
          </div>
        </div>

        <div class="form-row mt-3">
          <div class="col-12">
            <div class="custom-control custom-checkbox section-agreements">
              <input
                type="checkbox"
                class="custom-control-input"
                id="monthlyNewslettersSubscriptionActivated"
                [formControl]="formGroup.get('monthlyNewslettersSubscriptionActivated')"
              />
              <label class="custom-control-label" for="monthlyNewslettersSubscriptionActivated">
                {{ "LABELS.SIGN_ME_UP_MONTHLY_NEWSLETTER" | translate }}
              </label>
            </div>
          </div>

          <div class="col-12">
            <div class="custom-control custom-checkbox section-agreements">
              <input
                type="checkbox"
                class="custom-control-input"
                id="advertisingMessagesSubscriptionActivated"
                [formControl]="formGroup.get('advertisingMessagesSubscriptionActivated')"
              />
              <label class="custom-control-label" for="advertisingMessagesSubscriptionActivated">
                {{ "LABELS.I_AGREE_TO_RECEIVE_MARKETING_INFO" | translate }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="form-section" id="login-attempts-info-section">
      <div class="container">
        <div class="form-row form-row-header-section">
          <div class="col-12">
            <div class="form-section-title">{{ "COMPANY.LOGIN_HISTORY" | translate }}</div>
          </div>
        </div>
        <div class="form-row">
          <table class="login-attempts-table">
            <thead>
              <tr>
                <td class="col-icon"></td>
                <td class="col-timestamp">{{ "LABELS.DATE" | translate }}</td>
                <td class="col-ip">{{ "LABELS.IP" | translate }}</td>
                <td class="col-error">{{ "LABELS.ERROR" | translate }}</td>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let loginAttempt of loginAttempts">
                <td [attr.data-label]="'LABELS.IS_SUCCESS' | translate" class="col-icon">
                  <div class="login-attempt-icon">
                    <i
                      [ngClass]="{ 'icon-ic_close': !loginAttempt.isLoginSuccessful, 'icon-ic_Check': loginAttempt.isLoginSuccessful }"
                    ></i>
                  </div>
                </td>
                <td [attr.data-label]="'LABELS.TIMESTAMP' | translate" class="col-timestamp">
                  <div>{{ loginAttempt.timestamp | customDateTimeByUtc }}</div>
                </td>
                <td [attr.data-label]="'LABELS.IP' | translate" class="col-ip">
                  <div>{{ loginAttempt.ipAddress }}</div>
                </td>
                <td [attr.data-label]="loginAttempt.error ? ('LABELS.ERROR' | translate) : ''" class="col-error">
                  <div *ngIf="loginAttempt.error">{{ loginError(loginAttempt.error) | translate : { minutes: 5 } }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <div class="container" [ngStyle]="{ 'padding-bottom': '65px' }">
      <div class="row">
        <div class="col-12 text-center">
          <button class="btn btn-secondary mx-1 mb-2" (click)="getDeletionBlockers()">{{ "BUTTON.CANCEL_MY_ACCOUNT" | translate }}</button>
          <button class="btn btn-primary mx-1 mb-2" (click)="save()">{{ "BUTTON.SAVE" | translate }}</button>
        </div>
      </div>
    </div>
  </form>
</div>

<app-verify-phone-number [phone]="formGroup.get(['phoneNumber']).value"></app-verify-phone-number>
<input inputmode="decimal" [pattern]="integerInputMap.pattern" #hiddeninput [ngStyle]="{ position: 'fixed', bottom: '200vh' }" />

<custom-modal [(open)]="openCancelAccountModal" [header]="'CANCEL_ACCOUNT.MODAL_HEADER'">
  <div
    [innerHTML]="
      (deletionBlockers?.canUserBeDeleted ? 'CANCEL_ACCOUNT.MESSAGE' : 'CANCEL_ACCOUNT.CAN_NOT_CANCEL_ACCOUNT_MESSAGE') | translate
    "
  ></div>
  <form *ngIf="deletionBlockers?.canUserBeDeleted" (ngSubmit)="cancelAccount()">
    <div class="form-row">
      <div class="col-12">
        <app-control-wrapper [control]="deletionReasonControl">
          <label for="deletionReason" control-label>
            {{ "CANCEL_ACCOUNT.WHY_ARE_YOU_CANCELING_YOUR_ACCOUNT" | translate }}
          </label>
          <textarea
            type="text"
            [rows]="4"
            [formControl]="deletionReasonControl"
            class="form-control"
            id="deletionReason"
            name="deletionReason"
            [dropSpecialCharacters]="false"
            [patterns]="CUSTOM_MASK"
            [mask]="'F*'"
            [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
            control-wrapper
          ></textarea>
        </app-control-wrapper>
      </div>
    </div>
  </form>
  <button footer-action class="btn btn-secondary" type="button" (click)="openCancelAccountModal = false">
    {{ "BUTTON.CLOSE" | translate }}
  </button>
  <button *ngIf="deletionBlockers?.canUserBeDeleted" footer-action class="btn btn-primary" type="button" (click)="cancelAccount()">
    {{ "BUTTON.CANCEL_ACCOUNT" | translate }}
  </button>
  <button *ngIf="!deletionBlockers?.canUserBeDeleted" footer-action class="btn btn-primary" type="button" (click)="contactSupport()">
    {{ "BUTTON.CONTACT_SUPPORT" | translate }}
  </button>
</custom-modal>
